import type { MatchDto } from "@/types/app/MatchDto";
import {
	Button,
	Drawer,
	DrawerBody,
	DrawerContent,
	DrawerFooter,
	DrawerHeader,
	useDisclosure,
} from "@nextui-org/react";
import { MatchCard } from "./MatchCard";

type MatchDrawerProps = {
	matches: MatchDto[];
	type: "results" | "matches";
};

export const MatchDrawer = ({ matches, type }: MatchDrawerProps) => {
	const { isOpen, onOpen, onOpenChange } = useDisclosure();

	const sectionName = type === "results" ? "Výsledky" : "Zápasy";

	return (
		<>
			<Button onPress={onOpen} size="sm">
				{sectionName}
			</Button>
			<Drawer isOpen={isOpen} onOpenChange={onOpenChange} size="lg">
				<DrawerContent>
					{(onClose) => (
						<>
							<DrawerHeader className="flex flex-col gap-1 text-center">
								{type === "results"
									? `${sectionName} za poslední týden`
									: `Nadcházející ${sectionName.toLowerCase()}`}
							</DrawerHeader>
							<DrawerBody>
								{matches.length > 0 ? (
									matches.map((match) => (
										<MatchCard
											key={match.id}
											match={match}
											type={type === "results" ? "result" : "match"}
										/>
									))
								) : (
									<p className="text-center uppercase text-semibold ">
										Nebyly nalezeny žádné {sectionName.toLowerCase()}
									</p>
								)}
							</DrawerBody>
							<DrawerFooter>
								<Button color="danger" variant="light" onPress={onClose}>
									Zavřít
								</Button>
							</DrawerFooter>
						</>
					)}
				</DrawerContent>
			</Drawer>
		</>
	);
};
